(function () {
  'use strict';

  // ============================================================
  // CONFIG — replace WEBHOOK_URL once the Apps Script is deployed
  // ============================================================
  var WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbzDVMjDACmD_uP6BSsohR_OvOfAK-5QOAIDea8_sqlOfLynh5EH0QibjVzBpSRdO44p-A/exec';
  var SHARED_SECRET = 'mps-quiz-9f2b7a1d4e8c3f6a0b5d9e2c7f1a4b8d';

  var ASSETS = {
    hero: 'https://cdn.shopify.com/s/files/1/2099/1633/files/multi-peptide-serum-5359398.png?v=1786441815',
    video: 'https://cdn.shopify.com/videos/c/vp/f6bd027782354037a11ea0549c85dbc1/f6bd027782354037a11ea0549c85dbc1.SD-480p-0.9Mbps-91288712.mp4',
    icons: [
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-matrixyl3000.png?v=1786421977',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-synthe6.png?v=1786492168',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-syncoll.png?v=1786421977',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-coppertripeptide.png?v=1786421978',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-tegopep417.png?v=1786425969',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-pephatight.png?v=1786425969',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-acetylhexapeptide8.png?v=1786425969',
      'https://cdn.shopify.com/s/files/1/2099/1633/files/icon-panthenol.png?v=1786425969'
    ]
  };

  // ============================================================
  // QUESTION BANK — 33 questions, transcribed from the design spec (v3)
  // Option order/correct index here match the spec's fixed A/B/C/D layout;
  // actual on-screen order is re-shuffled per attempt, see buildRuntimeQuestions().
  // ============================================================
  var QUESTION_BANK = [
    { id: 'A1', section: 'A', critical: true, q: 'What is the pH of the Multi-Peptide Serum?', options: ['3.0–3.2', '6.5–7.8', '5.0–5.5', '7.0–8.0'], correct: 2 },
    { id: 'A2', section: 'A', critical: false, q: 'What is the retail price of the Multi-Peptide Serum?', options: ['$99', '$139', '$109', '$129'], correct: 1 },
    { id: 'A3', section: 'A', critical: false, q: 'Which peptide is specifically valued as a trace-mineral, barrier-supporting ingredient?', options: ['Palmitoyl Tripeptide-38', 'Copper Tripeptide-1', 'Tetrapeptide-21', 'Acetyl Hexapeptide-8'], correct: 1 },
    { id: 'A4', section: 'A', critical: false, q: "Which peptide targets six key structural components of the skin matrix, helping to visibly rebuild and refill the look of wrinkles?", options: ['Palmitoyl Tripeptide-38', 'Palmitoyl Tripeptide-5', 'Tetrapeptide-21', 'Palmitoyl Tripeptide-1'], correct: 0 },
    { id: 'A5', section: 'A', critical: false, q: 'Which peptide helps soften the appearance of expression lines?', options: ['Tetrapeptide-21', 'Palmitoyl Tripeptide-5', 'Acetyl Hexapeptide-8', 'Palmitoyl Tripeptide-38'], correct: 2 },
    { id: 'A6', section: 'A', critical: true, q: 'What is the correct amount and frequency for applying the Multi-Peptide Serum?', options: ['One pump, twice weekly', 'A full dropper, daily', 'Two pumps (0.5ml), daily', 'Two pumps, twice weekly'], correct: 2 },
    { id: 'A7', section: 'A', critical: true, q: 'Which preservative-related ingredients does the Multi-Peptide Serum NOT contain?', options: ['Parabens only', 'Phenoxyethanol only', 'It contains both', 'Both Parabens and Phenoxyethanol'], correct: 3 },
    { id: 'A8', section: 'A', critical: true, q: 'What form of Vitamin C is used in the standalone Vitamin C Serum?', options: ['Ascorbyl Palmitate', 'L-Ascorbic Acid', 'Ascorbyl Tetraisopalmitate', 'Sodium Ascorbyl Phosphate'], correct: 1 },
    { id: 'A9', section: 'A', critical: false, q: 'What form of Vitamin C is used in Skin Renewal Hero?', options: ['L-Ascorbic Acid', 'Ascorbyl Tetraisopalmitate', 'Ascorbyl Palmitate', 'Magnesium Ascorbyl Phosphate'], correct: 1 },
    { id: 'A10', section: 'A', critical: false, q: 'What do Palmitoyl Tripeptide-1 and Palmitoyl Tetrapeptide-7 (the two peptides inside Matrixyl® 3000) primarily support?', options: ['Exfoliation and cell turnover', 'Oil control', "The skin's natural collagen and repair signalling", 'Sun protection'], correct: 2 },
    { id: 'A11', section: 'A', critical: false, q: "How does the Barrier Hydration Complex's pH compare to the Multi-Peptide Serum's, and why does that matter for pairing them?", options: ["Very different, they shouldn't be paired", 'Closely matched, safe to layer directly', 'Barrier Hydration Complex is far more alkaline, avoid pairing', 'Neither product has a measurable pH'], correct: 1 },
    { id: 'A12', section: 'A', critical: false, q: "What does Pepha®-Tight contribute to the Multi-Peptide Serum, even though it isn't a peptide?", options: ['Deep exfoliation', 'Sun protection', 'An instant tightening sensation with longer-term firming benefits', 'Fragrance'], correct: 2 },
    { id: 'A13', section: 'A', critical: true, q: 'Is the Multi-Peptide Serum safe to recommend during pregnancy or breastfeeding?', options: ['No, never', 'Only in the third trimester', 'Only if diluted', 'Yes, no restriction'], correct: 3 },
    { id: 'A14', section: 'A', critical: false, q: 'Is the Multi-Peptide Serum suitable for daily use?', options: ['Yes, daily, morning or night', 'No, twice weekly only', 'Only at night', 'Only three times a week'], correct: 0 },

    { id: 'B1', section: 'B', critical: true, q: "A client's current routine includes the Vitamin C Serum every morning. She wants to add the Multi-Peptide Serum and asks if she should apply it right after. What do you recommend?", options: ['Apply them back-to-back for maximum benefit', 'Stop using the Vitamin C Serum altogether', 'Use the Multi-Peptide Serum at night instead, keep Vitamin C Serum in the morning', "It doesn't matter, order and timing make no difference"], correct: 2 },
    { id: 'B2', section: 'B', critical: true, q: "A client asks why she can't layer her Vitamin C Serum and the Multi-Peptide Serum together. What's the accurate explanation?", options: ['"They just don\'t smell good together"', '"The Vitamin C Serum is much more acidic, and copper in the peptide serum can speed up how quickly the Vitamin C breaks down"', '"There\'s no real reason, it\'s just brand policy"', '"Vitamin C cancels out anything applied after it"'], correct: 1 },
    { id: 'B3', section: 'B', critical: false, q: 'A client uses Skin Renewal Hero as her night moisturiser and wants to add the Multi-Peptide Serum underneath it. Should you apply the same caution as with the standalone Vitamin C Serum?', options: ['Yes, always separate any Vitamin C-containing product from the peptide serum', "No, because Skin Renewal Hero doesn't contain Vitamin C at all", 'Yes, but only for clients over 40', 'No, Skin Renewal Hero uses a different, more stable form of Vitamin C than the standalone serum, so layering is fine'], correct: 3 },
    { id: 'B4', section: 'B', critical: true, q: "A client mentions she's 10 weeks pregnant and wants an anti-ageing routine similar to what retinol gave her a few years ago. What's the safest recommendation?", options: ['The Multi-Peptide Serum plus The Daily Remedy', 'The Vitamin A Corrector, at a reduced frequency', "Skin Renewal Hero, since it's a moisturiser rather than a dedicated retinol serum", "No skincare at all until she's finished breastfeeding"], correct: 0 },
    { id: 'B5', section: 'B', critical: true, q: "A regular client on the Vitamin A Corrector 3x/week tells you she's trying to conceive and needs to pause it. What can you recommend to keep an active routine going in the meantime?", options: ['Nothing, she should use no skincare at all', 'The Multi-Peptide Serum, since it has no pregnancy restriction and can fill that gap safely', 'A stronger dose of the Vitamin A Corrector to compensate before she stops', "Wait until she's finished breastfeeding to use anything"], correct: 1 },
    { id: 'B6', section: 'B', critical: false, q: 'A client wants to use the AHA Power Exfoliant and the Multi-Peptide Serum. Can they go in the same session?', options: ['Never in the same week', 'Only the AHA Power Exfoliant is needed, skip the serum', 'Apply both at once without rinsing between them', 'Yes, apply the AHA Power Exfoliant, rinse it off, then follow with the Multi-Peptide Serum'], correct: 3 },
    { id: 'B7', section: 'B', critical: false, q: 'A client with a known fragrance sensitivity is nervous about trying a new serum. What can you tell her specifically about the Multi-Peptide Serum?', options: ["It's formulated without fragrance or dyes, making it a safe option to try", 'It contains a light natural fragrance, so caution is needed', 'All serums should be avoided by fragrance-sensitive clients', "It's not suitable for sensitive skin"], correct: 0 },
    { id: 'B8', section: 'B', critical: false, q: "A client wants a simple daily routine focused on firmness and prevention, nothing too strong. What's the best-fit recommendation?", options: ['Vitamin A Corrector nightly', 'AHA Power Exfoliant daily', 'Multi-Peptide Serum, Barrier Hydration Complex, and All Day Hydration', 'Vitamin C Serum alone, no moisturiser'], correct: 2 },
    { id: 'B9', section: 'B', critical: false, q: "A client with breakout-prone skin wants a peptide serum as her very first active product. What's the better opening move?", options: ['Multi-Peptide Serum immediately', "Vitamin A Corrector, since it's strongest", "Tell her peptides don't work for breakout-prone skin", 'Barrier Hydration Complex or AHA Power Exfoliant first, then introduce the Multi-Peptide Serum once breakouts settle'], correct: 3 },
    { id: 'B10', section: 'B', critical: false, q: "A client is booked in for a course of skin needling treatments. What's the strongest home-care recommendation between sessions?", options: ['AHA Power Exfoliant', 'Multi-Peptide Serum, since needling increases penetration of peptides that otherwise struggle to absorb', 'Vitamin A Corrector, for maximum strength', 'No home care is needed between sessions'], correct: 1 },
    { id: 'B11', section: 'B', critical: false, q: 'A client wants a full but gentle routine for sensitive, reactive skin. Which combination fits best?', options: ['Vitamin A Corrector, AHA Power Exfoliant, Vitamin C Serum', 'Multi-Peptide Serum and The Daily Remedy, morning and night', 'Multi-Peptide Serum and Miracle Facial Oil Complex only', 'AHA Power Exfoliant daily to build tolerance'], correct: 1 },
    { id: 'B12', section: 'B', critical: false, q: 'A client wants a complete anti-ageing routine and is comfortable using retinol. How should the Vitamin A Corrector and Multi-Peptide Serum be sequenced across her week?', options: ['Vitamin A Corrector on its 3x/week nights; Multi-Peptide Serum on the other nights or mornings', 'Both every night, one after the other', 'Multi-Peptide Serum only, retinol should never be paired with it', 'Alternate which one she uses each month'], correct: 0 },
    { id: 'B13', section: 'B', critical: false, q: 'A client getting ready for a special event is worried her Multi-Peptide Serum will interfere with her makeup application. What do you tell her?', options: ["It's lightweight and fast-absorbing, so it layers cleanly under makeup without pilling", 'She should skip her serum entirely on makeup days', 'It will make her foundation slide off throughout the day', 'It can only be worn with mineral makeup'], correct: 0 },
    { id: 'B14', section: 'B', critical: false, q: "A client asks whether she still needs sunscreen on days she uses the Multi-Peptide Serum. What's the correct guidance?", options: ['No, the peptide serum provides its own sun protection', 'Only in summer months', 'Only if she skips her moisturiser that day', 'Yes, the Multi-Peptide Serum has no SPF, so sunscreen is still essential'], correct: 3 },
    { id: 'B15', section: 'B', critical: false, q: "A client on a budget says the Multi-Peptide Serum feels expensive next to a drugstore option. What's the best reframe?", options: ['Reframe around cost-per-use (one bottle lasts roughly 60 applications at two pumps daily), and explain that the formula uses science-backed concentrations of each active, which costs more to produce than a typical drugstore formula', 'Agree and suggest the cheaper option', 'Insist price reflects quality with no further explanation', 'Offer an unplanned discount immediately'], correct: 0 },
    { id: 'B16', section: 'B', critical: false, q: 'A client says "I already have a peptide serum from another brand." What\'s the strongest response?', options: ['"All peptide serums are basically identical"', '"She should stop using it immediately and switch"', '"Avoid the comparison entirely"', '"Ask what peptides it lists, most use only 1-3, while this one uses 7 pure peptides across different mechanisms"'], correct: 3 },
    { id: 'B17', section: 'B', critical: false, q: 'A client expects visible results within 2-3 days of starting the Multi-Peptide Serum. How do you set expectations?', options: ['Explain peptides work cumulatively, and encourage her to judge results after 4-6 weeks', "Confirm that's realistic", "Tell her to return the product if nothing changes in 3 days", 'Avoid discussing timelines at all'], correct: 0 },
    { id: 'B18', section: 'B', critical: false, q: 'A client loves Skin Renewal Hero as her night moisturiser and wants extra firming benefit without adding more Vitamin A. What\'s a good addition to her routine?', options: ['The Vitamin A Corrector, for extra strength', 'The AHA Power Exfoliant, applied nightly', 'Nothing else should be added to her routine', 'The Multi-Peptide Serum underneath Skin Renewal Hero, since it adds no extra Vitamin A but still boosts firmness'], correct: 3 },
    { id: 'B19', section: 'B', critical: false, q: 'A client picks up the Multi-Peptide Serum and asks "what\'s this one?" Which response best describes the product?', options: ['"This is our most advanced serum in the range: 8 active technologies, including 7 true peptides, working together in one lightweight formula. Instead of targeting just one thing, it\'s addressing firmness, texture, fine lines, and skin barrier support all at once. It\'s suitable for daily use and layers under anything else in your routine."', '"This is a clinical-strength exfoliating treatment that uses a blend of AHAs and BHAs to resurface the skin, best used two to three times a week rather than daily, and it\'s particularly effective for clients dealing with congestion, texture, or dullness from a buildup of dead skin cells."', '"This is a brightening treatment built around a high dose of Vitamin C, designed to fade pigmentation and even out skin tone over several weeks, and it works best paired with SPF each morning since it can increase photosensitivity if used without daily sun protection."', '"This is a powerful anti-wrinkle treatment that works like a mild retinol, gently exfoliating the surface layer to reveal smoother skin underneath, with visible results in just a few days of nightly use, so it\'s best introduced gradually alongside a strong moisturiser."'], correct: 0 }
  ];

  // ============================================================
  // RUNTIME SHUFFLE — re-order each question's options per attempt so a
  // fixed sequence can't be memorized or compared between therapists.
  // ============================================================
  function shuffleArray(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function buildRuntimeQuestions(bank) {
    return bank.map(function (q) {
      var order = shuffleArray([0, 1, 2, 3]);
      var options = order.map(function (origIndex) { return q.options[origIndex]; });
      return { id: q.id, section: q.section, critical: q.critical, q: q.q, options: options, correct: order.indexOf(q.correct) };
    });
  }

  var QUESTIONS = buildRuntimeQuestions(QUESTION_BANK);

  var TOTAL = QUESTIONS.length; // 33
  var SECTION_A_COUNT = QUESTIONS.filter(function (q) { return q.section === 'A'; }).length; // 14

  // ============================================================
  // STATE
  // ============================================================
  var state = {
    screen: 'intro', // intro | checking | blocked | transition | quiz | submitting | done | error
    name: '',
    index: 0,
    answers: new Array(TOTAL).fill(null),
    blockedDate: '',
    submitError: ''
  };

  function normalizeName(n) {
    return String(n || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function fmtDate(raw) {
    var d = new Date(raw);
    if (isNaN(d.getTime())) return String(raw);
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  // ============================================================
  // SCORING
  // ============================================================
  function computeResults() {
    var missed = [];
    var overallCorrect = 0;
    var criticalCorrect = 0;
    var criticalTotal = 0;

    QUESTIONS.forEach(function (q, i) {
      var given = state.answers[i];
      var isRight = given === q.correct;
      if (q.critical) {
        criticalTotal++;
        if (isRight) criticalCorrect++;
      }
      if (isRight) {
        overallCorrect++;
      } else {
        missed.push({
          id: q.id,
          critical: q.critical,
          question: q.q,
          given: given === null ? '(no answer)' : q.options[given],
          correct: q.options[q.correct]
        });
      }
    });

    var overallPercent = Math.round((overallCorrect / TOTAL) * 1000) / 10;
    var criticalPassed = criticalTotal === 0 ? true : (criticalCorrect / criticalTotal) >= 0.9;
    var overallPassed = (overallCorrect / TOTAL) >= 0.75;

    return {
      name: state.name,
      overallCorrect: overallCorrect,
      overallTotal: TOTAL,
      overallPercent: overallPercent,
      criticalCorrect: criticalCorrect,
      criticalTotal: criticalTotal,
      criticalPassed: criticalPassed,
      overallPassed: overallPassed,
      needsFollowUp: !criticalPassed || !overallPassed,
      missed: missed
    };
  }

  // ============================================================
  // NETWORK
  // ============================================================
  function checkName(name, done) {
    var url = WEBHOOK_URL + '?action=check&name=' + encodeURIComponent(name) + '&secret=' + encodeURIComponent(SHARED_SECRET);
    fetch(url, { method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (data) { done(null, data); })
      .catch(function (err) { done(err); });
  }

  function submitResults(results, done) {
    var payload = Object.assign({ secret: SHARED_SECRET }, results);
    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' }, // avoids a CORS preflight against Apps Script
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { done(null, data); })
      .catch(function (err) { done(err); });
  }

  // ============================================================
  // RENDER
  // ============================================================
  var root = document.getElementById('mps-quiz-root');
  if (!root) return;

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }

  function render() {
    root.innerHTML = '';
    if (state.screen === 'intro') root.appendChild(renderIntro());
    else if (state.screen === 'checking') root.appendChild(renderStatus({ icon: '🧬', title: 'One moment…', body: 'Checking your details before we begin.', spinner: true }));
    else if (state.screen === 'blocked') root.appendChild(renderBlocked());
    else if (state.screen === 'transition') root.appendChild(renderTransition());
    else if (state.screen === 'quiz') root.appendChild(renderQuiz());
    else if (state.screen === 'submitting') root.appendChild(renderStatus({ icon: '🧬', title: 'Submitting…', body: 'Sending your responses through.', spinner: true }));
    else if (state.screen === 'done') root.appendChild(renderDone());
    else if (state.screen === 'error') root.appendChild(renderError());
  }

  function renderIntro() {
    var wrap = h('div', { class: 'shell' });
    var grid = h('div', { class: 'intro-grid card' });

    var media = h('div', { class: 'intro-media' });
    var vid = h('video', { autoplay: '', muted: '', loop: '', playsinline: '', preload: 'auto', 'aria-hidden': 'true' });
    vid.muted = true;
    vid.playsInline = true;
    vid.src = ASSETS.video;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      vid.removeAttribute('autoplay');
    } else {
      var playPromise = vid.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    }
    media.appendChild(vid);
    var orbit = h('div', { class: 'icon-orbit' });
    ASSETS.icons.slice(0, 8).forEach(function (src) {
      orbit.appendChild(h('img', { src: src, alt: '', loading: 'lazy' }));
    });
    media.appendChild(orbit);

    var copy = h('div', { class: 'intro-copy' });
    copy.appendChild(h('p', { class: 'eyebrow' }, ['Therapist Training · Multi-Peptide Serum']));
    copy.appendChild(h('h1' , {}, ['Know the Formula, Own the Conversation']));
    copy.appendChild(h('p', { class: 'lede' }, ['33 questions across two parts: what you know about the formula, and how you’d use it in a real consult. Takes about 12–15 minutes.']));

    var stats = h('div', { class: 'stat-row' });
    stats.appendChild(h('div', { class: 'stat' }, [h('b', {}, ['14']), h('span', {}, ['Product facts'])]));
    stats.appendChild(h('div', { class: 'stat' }, [h('b', {}, ['19']), h('span', {}, ['Client scenarios'])]));
    stats.appendChild(h('div', { class: 'stat' }, [h('b', {}, ['1']), h('span', {}, ['Attempt only'])]));
    copy.appendChild(stats);

    var label = h('label', {}, [
      h('span', { class: 'field-label' }, ['Your full name']),
    ]);
    var input = h('input', { class: 'name-input', type: 'text', placeholder: 'e.g. Jamie Nguyen', autocomplete: 'name' });
    label.appendChild(input);
    copy.appendChild(label);

    var errMsg = h('p', { class: 'fine-print', style: 'color:var(--critical); display:none;' }, []);
    copy.appendChild(errMsg);

    var startBtn = h('button', { class: 'btn-primary', onclick: function () { handleStart(input.value, errMsg, startBtn); } }, ['Begin Assessment →']);
    copy.appendChild(startBtn);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleStart(input.value, errMsg, startBtn);
    });

    copy.appendChild(h('p', { class: 'fine-print' }, ['This assessment allows one attempt per person. Your results go straight to your managers — no score is shown to you here.']));

    grid.appendChild(media);
    grid.appendChild(copy);
    wrap.appendChild(grid);
    return wrap;
  }

  function handleStart(nameRaw, errEl, btn) {
    var name = String(nameRaw || '').trim();
    if (!name) {
      errEl.textContent = 'Please enter your name to begin.';
      errEl.style.display = 'block';
      return;
    }
    state.name = name;
    state.screen = 'checking';
    render();

    checkName(name, function (err, data) {
      if (err) {
        state.screen = 'intro';
        render();
        var i2 = root.querySelector('.name-input');
        if (i2) i2.value = name;
        var e2 = root.querySelector('.intro-copy .fine-print');
        if (e2) { e2.textContent = 'Couldn’t reach the server to check your record — check your connection and try again.'; e2.style.display = 'block'; e2.style.color = 'var(--critical)'; }
        return;
      }
      if (data.status === 'duplicate') {
        state.blockedDate = data.completedDate || '';
        state.screen = 'blocked';
        render();
        return;
      }
      state.screen = 'quiz';
      state.index = 0;
      render();
    });
  }

  function renderBlocked() {
    var wrap = h('div', { class: 'shell' });
    var card = h('div', { class: 'card status-card' });
    card.appendChild(h('div', { class: 'mark' }, ['🔒']));
    card.appendChild(h('h2', {}, ['Already completed']));
    var dateStr = state.blockedDate ? fmtDate(state.blockedDate) : 'an earlier date';
    card.appendChild(h('p', {}, ['It looks like you’ve already completed this quiz on ' + dateStr + '. If this is a mistake, contact your manager.']));
    wrap.appendChild(card);
    return wrap;
  }

  function renderStatus(opts) {
    var wrap = h('div', { class: 'shell' });
    var card = h('div', { class: 'card status-card' });
    if (opts.spinner) card.appendChild(h('div', { class: 'spinner', 'aria-hidden': 'true' }));
    else card.appendChild(h('div', { class: 'mark' }, [opts.icon]));
    card.appendChild(h('h2', {}, [opts.title]));
    card.appendChild(h('p', {}, [opts.body]));
    wrap.appendChild(card);
    return wrap;
  }

  function renderTransition() {
    var wrap = h('div', { class: 'shell' });
    var card = h('div', { class: 'card status-card' });
    card.appendChild(h('div', { class: 'mark' }, ['🧬']));
    card.appendChild(h('p', { class: 'eyebrow' }, ['Section A complete']));
    card.appendChild(h('h2', {}, ['Now, applying it in the room']));
    card.appendChild(h('p', {}, ['From here it’s less about facts and more about the conversation — what would you actually recommend, and why.']));
    card.appendChild(h('button', { class: 'btn-primary', onclick: function () { state.screen = 'quiz'; render(); } }, ['Continue →']));
    wrap.appendChild(card);
    return wrap;
  }

  function renderQuiz() {
    var q = QUESTIONS[state.index];
    var wrap = h('div', { class: 'quiz-shell' });

    var railWrap = h('div', { class: 'rail-wrap' });
    var rail = h('div', { class: 'rail' });
    QUESTIONS.forEach(function (qq, i) {
      var cls = 'seg' + (qq.section === 'B' ? ' section-b' : '');
      if (i < state.index) cls += ' filled';
      if (i === state.index) cls += ' current';
      rail.appendChild(h('div', { class: cls }));
    });
    railWrap.appendChild(rail);
    var meta = h('div', { class: 'rail-meta' });
    meta.appendChild(h('span', { class: 'section-name' }, [q.section === 'A' ? 'Product knowledge' : 'Client scenarios']));
    meta.appendChild(h('span', { class: 'count' }, ['Question ' + (state.index + 1) + ' of ' + TOTAL]));
    railWrap.appendChild(meta);
    wrap.appendChild(railWrap);

    var card = h('div', { class: 'card quiz-card' });
    card.appendChild(h('p', { class: 'q-text' }, [q.q]));

    var optWrap = h('div', { class: 'options' });
    var letters = ['A', 'B', 'C', 'D'];
    q.options.forEach(function (opt, i) {
      var selected = state.answers[state.index] === i;
      var btn = h('button', {
        class: 'option' + (selected ? ' selected' : ''),
        onclick: function () {
          state.answers[state.index] = i;
          render();
        }
      }, [h('span', { class: 'letter' }, [letters[i]]), h('span', {}, [opt])]);
      optWrap.appendChild(btn);
    });
    card.appendChild(optWrap);

    var nav = h('div', { class: 'quiz-nav' });
    var backBtn = h('button', {
      class: 'btn-ghost',
      style: state.index === 0 ? 'visibility:hidden' : '',
      onclick: function () { if (state.index > 0) { state.index--; render(); } }
    }, ['← Back']);

    var isLast = state.index === TOTAL - 1;
    var atSectionBoundary = q.section === 'A' && state.index === SECTION_A_COUNT - 1;
    var nextLabel = isLast ? 'Submit Assessment' : 'Next →';
    var nextBtn = h('button', { class: 'btn-primary' }, [nextLabel]);
    if (state.answers[state.index] === null) nextBtn.setAttribute('disabled', 'disabled');
    nextBtn.addEventListener('click', function () {
      if (state.answers[state.index] === null) return;
      if (isLast) {
        doSubmit();
        return;
      }
      state.index++;
      if (atSectionBoundary) {
        state.screen = 'transition';
      }
      render();
    });

    nav.appendChild(backBtn);
    nav.appendChild(nextBtn);
    card.appendChild(nav);

    wrap.appendChild(card);
    return wrap;
  }

  function doSubmit() {
    state.screen = 'submitting';
    render();
    var results = computeResults();
    submitResults(results, function (err, data) {
      if (err) {
        state.submitError = 'We couldn’t reach the server. Your answers are safe — try again when you’re back online.';
        state.screen = 'error';
        render();
        return;
      }
      if (data.status === 'duplicate') {
        state.blockedDate = data.completedDate || '';
        state.screen = 'blocked';
        render();
        return;
      }
      if (data.status !== 'ok') {
        state.submitError = 'Something went wrong on our end. Please try again.';
        state.screen = 'error';
        render();
        return;
      }
      state.screen = 'done';
      render();
    });
  }

  function renderError() {
    var wrap = h('div', { class: 'shell' });
    var card = h('div', { class: 'card status-card' });
    card.appendChild(h('div', { class: 'mark' }, ['⚠️']));
    card.appendChild(h('h2', {}, ["Couldn't submit"]));
    card.appendChild(h('p', {}, [state.submitError || 'Something went wrong. Please try again.']));
    card.appendChild(h('button', { class: 'btn-primary', onclick: doSubmit }, ['Try again']));
    wrap.appendChild(card);
    return wrap;
  }

  function renderDone() {
    var wrap = h('div', { class: 'shell' });
    var card = h('div', { class: 'card status-card' });
    card.appendChild(h('div', { class: 'mark' }, ['✓']));
    card.appendChild(h('h2', {}, ['Thanks, ' + state.name.split(' ')[0] + '.']));
    card.appendChild(h('p', {}, ['Your responses have been submitted. Your manager will follow up with you directly if there’s anything worth going over together.']));
    wrap.appendChild(card);
    return wrap;
  }

  render();
})();
